<ng-container>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.FILTERS.OPPORTUNITY_DATA.DATA_LABELS.PACKAGES"
    [dataService]="service"
    [formControl]="control"
    [isRequired]="true"
    [multiple]="true"
    [supportDataPassing]="false"
  ></automata-automation-replacement-chips>
</ng-container>
